import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FFLogo from "../../../img/FREEFIT_LOGO_new.png";
import { selectPartner } from "../../../store/partnerStore";
import { formatDate } from "../../../utils/dateUtils";
import ScreenHeader from "../../components/ScreenHeader";
import { getPartnerAsset } from "../../theme/partnerAssets";
import "./multipleEntryPassDetails.scss";

// V2 pass details ("הכרטיסייה שלי"). Presentational: receives the pass from
// the V1 screen gate; card artwork per partner via getPartnerAsset.
function MultipleEntryPassDetails({ pass }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const partner = useSelector(selectPartner);

  const isActive = pass?.IsAvailable;
  const total = pass?.PossibleNumberOfEntries ?? 0;
  // NumberOfEntries = entries already used
  const remaining = total - (pass?.NumberOfEntries ?? 0);
  const noEntriesLeft = remaining <= 0;

  return (
    <div className="mepd-v2">
      <ScreenHeader title={t("MY_PASS_TITLE")} onBack={() => navigate(-1)} />
      <div className="mepd-v2-body">
        <img src={FFLogo} alt="freefit" className="mepd-v2-logo" />

        <div className="mepd-v2-card">
          <img
            src={getPartnerAsset(partner, "passCardImg")}
            alt=""
            className={`mepd-v2-card-img${isActive ? "" : " mepd-v2-card-img--inactive"}`}
          />
          {isActive && (
            <div className="mepd-v2-card-counter">
              {!noEntriesLeft && <p className="mepd-v2-card-counter-label">{t("ENTRIES_REMAINING")}</p>}
              <p className={`mepd-v2-card-counter-value${noEntriesLeft ? " mepd-v2-card-counter-value--empty" : ""}`}>
                {noEntriesLeft ? t("NO_ENTRIES_LEFT") : t("ENTRIES_COUNT_OF_TOTAL", { remaining, total })}
              </p>
            </div>
          )}
        </div>

        <p className="mepd-v2-title">{t("MULTIPLE_ENTRY_PASS_DETAILS")}</p>
        <p className="mepd-v2-description">{t("MULTIPLE_ENTRY_PASS_VALID_ANYWHERE")}</p>
        <p className="mepd-v2-expiry">
          {isActive
            ? t("EXPIRES_ON", { date: formatDate(pass?.EndDate) })
            : t("EXPIRED", { date: formatDate(pass?.EndDate) })}
        </p>
      </div>
    </div>
  );
}

export default MultipleEntryPassDetails;
